import React from 'react';

import { useIntl } from 'react-intl';

import ConfirmDialog from 'components/confirm-dialog';

import { BodyComponent } from '../body-component';

interface IPickerAspectsUpdateDialog {
  showDialog: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const PickerAspectsUpdateDialog = ({
  showDialog,
  onConfirm,
  onCancel,
}: IPickerAspectsUpdateDialog) => {
  const { formatMessage } = useIntl();

  const heading = formatMessage({ id: 'productDetailResetHeading' });
  const content = formatMessage({ id: 'productDetailResetContent' });

  const confirmLabel = formatMessage({ id: 'reset' });
  const cancelLabel = formatMessage({ id: 'discard' });

  return showDialog ? (
    <ConfirmDialog
      showDialog={showDialog}
      modalAppearanceEventMessage="Confirmation: Picker Aspect will Reset Customizations to Default"
      bodyComponent={<BodyComponent heading={heading} content={content} />}
      confirmLabel={confirmLabel}
      cancelLabel={cancelLabel}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  ) : null;
};
